export default __webpack_public_path__ + "static/to-down--black-3158748b16431bbf22b8889df0b26da8.svg";